import { app } from '@/main';
import CoinStore from '@/views/Admin/CoinStore/CoinStore.vue';
import flagKeys from '@/constants/flagKeys';
import { Route } from '../route.model';

const validateRouteFlag = () => {
  return (
    app.$store.getters['manager/hasTwismWalletAccess'] &&
    app.$store.getters['flags/getFlags'].includes(flagKeys.coinStoreV1)
  );
};

const adminCoinStore = new Route(
  '/admin/coin-store',
  'coin-store-merchants',
  CoinStore,
  {
    isResponsive: true,
    requiresAuth: true,
    superRoot: true,
    navbar: {
      name: 'Merchants',
      icon: 'coin-rewarded'
    },
    customFlagValidator: validateRouteFlag,
    zendesk: {
      disabled: true
    }
  }
);

export { adminCoinStore };
export default adminCoinStore;
